import { Component, Input } from '@angular/core';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { NavController, NavParams } from 'ionic-angular';
import { EventDetailsModel } from '../../../../providers/event/event';


/**
 * Generated class for the EventKontaktPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-event-kontakt',
  templateUrl: 'event-kontakt.html',
})
export class EventKontaktPage {
  @Input("event")
  event: EventDetailsModel;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private iab: InAppBrowser) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventKontaktPage');
  }

  openWebPage(url) {
    let browser = this.iab.create(url);
    browser.show();
  }

}



// WEBPACK FOOTER //
// /src/pages/event/details/event-kontakt/event-kontakt.ts